import React, { useMemo } from 'react';

import { useTranslation } from '@lyearn/i18n';
import { Input, Stack } from '@lyearn/ui';

import { RatingLabelsFormFieldProps } from './types';

function RatingLabelsFormField(props: RatingLabelsFormFieldProps) {
  const { t } = useTranslation();
  const { maxValue, value, onChange } = props;

  const methods = useMemo(() => {
    return {
      onMinLabelChange: (minLabel: string) => {
        onChange({ maxLabel: value.maxLabel, minLabel });
      },
      onMaxLabelChange: (maxLabel: string) => {
        onChange({ minLabel: value.minLabel, maxLabel });
      },
    };
  }, [onChange, value.maxLabel, value.minLabel]);

  return (
    <Stack gapX={8}>
      <Input
        characterLimit={20}
        placeholder={t('Database:RatingLevels.Level', { count: 1 })}
        value={value.minLabel}
        onChangeText={methods.onMinLabelChange}
      />
      <Input
        characterLimit={20}
        placeholder={t('Database:RatingLevels.Level', { count: maxValue })}
        value={value.maxLabel}
        onChangeText={methods.onMaxLabelChange}
      />
    </Stack>
  );
}

export default RatingLabelsFormField;
